import { render, staticRenderFns } from "./ApprDtl.vue?vue&type=template&id=29ff9734&scoped=true"
import script from "./ApprDtl.vue?vue&type=script&lang=js"
export * from "./ApprDtl.vue?vue&type=script&lang=js"
import style0 from "./ApprDtl.vue?vue&type=style&index=0&id=29ff9734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ff9734",
  null
  
)

export default component.exports